module.exports = __webpack_public_path__ + "img/all_f_winter_event_banner_m_v1.4b6b76e.png";